import React from 'react';
import { useAuth } from '@components/MsalProvider';
import { UserRole } from '~types/types';
import Unauthorized from './Unauthorized';
import AuthLoading from './AuthLoading';

interface Props {
  children: React.ReactNode;
}

// Allowed roles that can access the application
const ALLOWED_ROLES: UserRole[] = [UserRole.Admin, UserRole.User, UserRole.Reader];

const AuthorizationGuard: React.FC<Props> = ({ children }) => {
  const { role, userName, loading, loginFailed } = useAuth();

  // Show loading while user data is being fetched
  if (loading) {
    return <AuthLoading />;
  }

  // Check if API call failed (403, network error, etc.)
  if (loginFailed) {
    return <Unauthorized userName={userName || ''} />;
  }

  // Check if user has an allowed role
  const isAuthorized = ALLOWED_ROLES.includes(role);

  if (!isAuthorized) {
    return <Unauthorized userName={userName || ''} />;
  }

  // User is authorized - render the app
  return <>{children}</>;
};

export default AuthorizationGuard;
